export const ADD_NEW_BANNER = "ADD_NEW_BANNER";
export const REMOVE_BANNER = "REMOVE_BANNER";